import { render, staticRenderFns } from "./DocumentNoteDialog.vue?vue&type=template&id=75489bae&scoped=true&"
import script from "./DocumentNoteDialog.vue?vue&type=script&lang=ts&"
export * from "./DocumentNoteDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentNoteDialog.vue?vue&type=style&index=0&id=75489bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75489bae",
  null
  
)

export default component.exports